import React from 'react';
import { useTranslation } from 'react-i18next';
import { SimpleModal } from '@livable/saas-react-components';
import ModalContent from './ModalContent';
export default function EditModal(_ref) {
  var _activeTransaction$po;
  let modalState = _ref.modalState,
    handleCloseExternal = _ref.handleCloseExternal,
    handleOpenExternal = _ref.handleOpenExternal,
    activeTransaction = _ref.activeTransaction,
    onSaveHandler = _ref.onSaveHandler;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: handleCloseExternal,
    handleOpen: handleOpenExternal,
    isOpen: modalState,
    title: t('resident_account.edit_recurring_transaction', {
      transactionType: activeTransaction === null || activeTransaction === void 0 || (_activeTransaction$po = activeTransaction.postType) === null || _activeTransaction$po === void 0 ? void 0 : _activeTransaction$po.toLowerCase()
    }),
    noFooter: true,
    noPadding: true
  }, /*#__PURE__*/React.createElement(ModalContent, {
    activeTransaction: activeTransaction,
    onSaveHandler: onSaveHandler,
    handleCloseExternal: handleCloseExternal
  }));
}